import { render } from "./headerElement.vue?vue&type=template&id=17120d79"
import script from "./headerElement.vue?vue&type=script&lang=js"
export * from "./headerElement.vue?vue&type=script&lang=js"

import "./headerElement.vue?vue&type=style&index=0&id=17120d79&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__